import { render, staticRenderFns } from "./TabFiche.vue?vue&type=template&id=b15e1b28"
import script from "./TabFiche.vue?vue&type=script&lang=js"
export * from "./TabFiche.vue?vue&type=script&lang=js"
import style0 from "./TabFiche.vue?vue&type=style&index=0&id=b15e1b28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports